
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './common/home/home.component';

import { MiteventsComponent } from './common/mitevents/mitevents.component';
import { ContactComponent } from './common/contact/contact.component';

import { SingleEventComponent } from './common/single-event/single-event.component';
import { EventDetailsComponent } from './shared/event-details/event-details.component';
import { NgModule } from '@angular/core';
import { PrivacyComponent } from './common/privacy/privacy.component';
import { NewHomeComponent } from './common/new-home/new-home.component';


export const routes: Routes = [
  
  { path: '', component: HomeComponent },
  { path: 'mitevents', component: MiteventsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'event-details/:id', component: EventDetailsComponent },
  { path: 'privacy', component: PrivacyComponent  },
  { path: 'newHome', component: NewHomeComponent },

  
  { path: 'single-event/:id', component: SingleEventComponent },
  { path: '', loadChildren: () => import('./careers/careers-routing.module').then(m => m.CareersRoutingModule) },
  { path: '', loadChildren: () => import('./insights/insights-routing.module').then(m => m.InsightsRoutingModule) },
  { path: '', loadChildren: () => import('./about/about-routing.module').then(m => m.AboutRoutingModule) },
  { path: '', loadChildren: () => import('./industries/industries-routing.module').then(m => m.IndustriesRoutingModule) },
  { path: '', loadChildren: () => import('./services/services-routing.module').then(m => m.ServicesRoutingModule) },




  { path: 'manufacturing/futek-casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'index.html', redirectTo: '/', pathMatch: 'full' }, 
  { path: 'case-studies/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'corporate-giving/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'cyber-security/dbservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'case-studies/test123', redirectTo: '/', pathMatch: 'full' },
  { path: 'retail/test123', redirectTo: '/', pathMatch: 'full' },
  { path: 'postpandamic/dbservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'cloudservices/blog-post-layout-one.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'cloudservices/m/ouropinion-casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'cloud-computing-services', redirectTo: '/cloudservices/', pathMatch: 'full' },
  { path: 'database-services/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'teams/linkedin.com/in/kumar-reddy-8a6200240', redirectTo: '/', pathMatch: 'full' },
  { path: 'teams/linkedin.com/in/siddartha-kusunuri-46237b276', redirectTo: '/', pathMatch: 'full' },
  { path: 'cyber-security/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'cloudservices/futek_casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'entertainment/futek_casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'finance/futek_casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'retail/futek_casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'cyber-security/test123', redirectTo: '/', pathMatch: 'full' },
  { path: 'manufacturing/futek_casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'migrate-cloud/dbservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'annualmeet.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'application-services/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'corporate-giving/test123', redirectTo: '/', pathMatch: 'full' },
  { path: 'portfolio.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'technology-staffing/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'operation-maintanance/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'RiskandControl.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'trainings.php', redirectTo: '/', pathMatch: 'full' },
  { path: 'openCms.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'Opportunities.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'personalisation-and-machine-learning.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'virtual.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'futek.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'DataScience.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'technology-staffing/dbservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'a-journey-of-a-project-manager-kishorenath-viswanathansarojini.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'career.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'a-journey-of-a-project-manager-kishore-viswanathan.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'personalize-and-machine-learning/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'operation-maintanance/dbservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'corporate-giving/dbservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'company.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'banking_industry_java_developer.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'technology-training/test123', redirectTo: '/', pathMatch: 'full' },
  { path: 'InternetIoT.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'Ecom.html', redirectTo: '/', pathMatch: 'full' },
  { path: 'technology-training/dbservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'migrate-cloud/test123', redirectTo: '/', pathMatch: 'full' },
  { path: 'operation-maintanance/test123', redirectTo: '/', pathMatch: 'full' },
  { path: 'h1b-visa/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'technology-training/applicationservices', redirectTo: '/', pathMatch: 'full' },
  { path: 'ai-solutions', redirectTo: '/', pathMatch: 'full' },
  { path: 'ai-on-manufacturing-challenges', redirectTo: '/', pathMatch: 'full' },
  { path: 'celebrating-women', redirectTo: '/', pathMatch: 'full' },
  { path: 'challenges-manufacturing-it-industry-4-0', redirectTo: '/', pathMatch: 'full' },
  { path: 'explore-jobs', redirectTo: '/', pathMatch: 'full' },
  { path: 'gen-ai-powered-talent-aquisition', redirectTo: '/', pathMatch: 'full' },
  { path: 'ai-on-manufacturing-challenges', redirectTo: '/', pathMatch: 'full' },
  { path: 'production-planning', redirectTo: '/', pathMatch: 'full' },
  { path: 'sensor_manufacturing_ci_cd_casestudy', redirectTo: '/', pathMatch: 'full' },
  { path: 'team', redirectTo: '/', pathMatch: 'full' },
  { path: 'teams', redirectTo: '/', pathMatch: 'full' },

  

  { path: '', redirectTo: '/home', pathMatch: 'full' }, 
  { path: 'home', component: HomeComponent },
  { path: '**', redirectTo: '/home' } 
 
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
  
})
export class AppRoutingModule { }
